export default "__VITE_ASSET__D4RuKl8u__"